import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

interface ThinkingSectionProps {
  content: string;
}

export function ThinkingSection({ content }: ThinkingSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!content || content.trim().length === 0) return null;

  return (
    <div className="mb-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={cn(
          'flex items-center gap-2 w-full px-3 py-2 rounded-lg',
          'text-sm text-muted-foreground hover:text-foreground',
          'hover:bg-muted/50 transition-colors',
          'border-0'
        )}
      >
        <ChevronRight
          className={cn('h-4 w-4 transition-transform', isExpanded && 'rotate-90')}
        />
        <span className="font-medium">Thinking...</span>
      </button>

      {isExpanded && (
        <div className="mt-2 px-3 py-2 text-sm text-muted-foreground/80 leading-relaxed border-l-2 border-border/50 ml-6">
          {content}
        </div>
      )}
    </div>
  );
}
